import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import GlobalStyles from './global-style';
import configureStore from './state';
import { fetchData } from './state/actions/createData';
import { domListeners } from './state/actions/createBrowserUtils';

import Header from './views/header';
import Footer from './views/footer';
// import Voroni from './views/voroni';
import Bubbles from './views/bubbles';
import Annotation from './views/annotation';
import Map from './views/map';
import List from './views/list';
import Tooltip from './views/tooltip';

const store = configureStore();

const element = (
  <Provider store={store}>
    <GlobalStyles />
    <div>
      <Header />
      <Map />
      <Annotation />
      <div className="chart-wrap">
        <Bubbles />
        <Tooltip />
      </div>
      <List />
      <Footer />
    </div>
  </Provider>
);

ReactDOM.render(element, document.getElementById('foot'));

/* Start up functions */
store.dispatch(domListeners());
store.dispatch(fetchData());
